// extracted by mini-css-extract-plugin
export default {"root":"archived_gift_cards_root__WSuy7","search_input":"archived_gift_cards_search_input__KA03X"};